(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-soccer/assets/javascripts/status.js') >= 0) return;  svs.modules.push('/components/themes/sport-soccer/assets/javascripts/status.js'); 
var svs = svs || {};

(function(svs) {
  svs.themes = svs.themes || {};
  svs.themes.sport_soccer = svs.themes.sport_soccer || {};

  svs.themes.sport_soccer.isEnded = function(status) {
    return !!_.contains([28, 31, 32, 33, 41], status);
  };
  svs.themes.sport_soccer.isFinished = function(status) {
    return !!_.contains([31, 32, 33, 41], status);
  };

  svs.themes.sport_soccer.isFullTimeOrPassed = function(status, options) {
    options = _.extend(
      {
        includeFullTime: true,
        includePauses: true,
        includeFinished: true
      },
      options
    );

    var statusesForOvertimeOrPenalties = [19, 20, 21, 22];

    if (options.includeFullTime) {
      statusesForOvertimeOrPenalties.push(31, 41);
    }

    if (options.includePauses) {
      statusesForOvertimeOrPenalties.push(16, 17, 18);
    }

    if (options.includeFinished) {
      statusesForOvertimeOrPenalties.push(32, 33);
    }

    return _.contains(statusesForOvertimeOrPenalties, status);
  };

  svs.themes.sport_soccer.matchNotice = function(match) {
    var matchStatus;
    switch (match.status) {
      case 16:
        matchStatus = 'Väntar på förlängning';
        break;
      case 17:
        matchStatus = 'Paus i förlängning';
        break;
      case 18:
        matchStatus = 'Väntar på straffläggning';
        break;
      case 20:
        matchStatus = 'Första övertidsperioden';
        break;
      case 21:
        matchStatus = 'Andra övertidsperioden';
        break;
      case 22:
        matchStatus = 'Straffläggning';
        break;
      case 23:
        matchStatus = 'Uppskjuten';
        break;
      case 24:
        matchStatus = 'Försenad matchstart';
        break;
      case 25:
        matchStatus = 'Inställd';
        break;
      case 26:
        matchStatus = 'Avbruten';
        break;
      case 28:
        matchStatus = 'Stoppad av domare';
        break;


      case 33:
        var penaltyResult = getPenaltyResult(match.result);
        matchStatus =
          'Straffar' + (penaltyResult.length > 0 ? ': ' + penaltyResult : '');
        break;
      default:
        matchStatus = '';
        break;
    }
    return matchStatus;
  };

  svs.themes.sport_soccer.isLive = function(status) {
    if (window.location.href.indexOf('isMocked') > -1) {
      return true;
    }

    return !!_.contains([6, 7, 15, 16, 17, 18, 19, 20, 21, 22], status);
  };

  svs.themes.sport_soccer.subscribeMatch = function(params) {
    return (
      svs.themes.isDateHoursDiff(params.time, -5) &&
      !svs.themes.sport_soccer.isEnded(params.status)
    );
  };

  svs.themes.sport_soccer.hasStarted = function(status) {
    return status > 0 && !_.contains([23, 24, 25], status);
  };

  function getPenaltyResult(result) {
    var pentaltyStr = '';
    _.each(result, function(oResult) {
      if (_.isObject(oResult)) {
        if (oResult.type === 4) {
          if (oResult.homePeriod && oResult.awayPeriod) {
            pentaltyStr = oResult.homePeriod + ' - ' + oResult.awayPeriod;
          }
        }
      }
    });
    return pentaltyStr;
  }

  svs.themes.sport_soccer.getStatusText = function(options) {
    var text = '',
      status,
      matchMinute;

    options = _.defaults({}, options, {
      statusId: null,
      startTime: null,
      statusTime: null,
      getStartTime: true
    });

    status = options.statusId;

    if (svs.themes.sport_soccer.isLive(status)) {
      switch (status) {
        case 15:
          text = 'HT';
          break;
        case 16:
        case 17:
        case 18:
          text = 'PAUS';
          break;
        case 19:
          text = 'ÖT';
          break;
        case 22:
          text = 'STR';
          break;
        default:
      }

      if (!text && options.statusTime) {
        matchMinute = Math.ceil(
          Math.abs(
            svs.themes.getDifferenceBetweenDates(
              options.statusTime,
              new Date().setSeconds(0, 0),
              'minutes',
              false
            )
          )
        );

        if (status === 6 && matchMinute > 45) {
          text = '45+';
        } else if (status === 7) {
          text = (matchMinute += 45) + "'";

          if (matchMinute > 90) {
            text = '90+';
          }
        } else if (status === 20) {
          text = (matchMinute += 90) + "'";

          if (matchMinute > 105) {
            text = '105+';
          }
        } else if (status === 21) {
          text = (matchMinute += 105) + "'";

          if (matchMinute > 120) {
            text = '120+';
          }
        } else {
          text = matchMinute + "'";
        }
      }
    } else if (svs.themes.sport_soccer.isEnded(status)) {
      switch (status) {
        case 32:
          text = 'ÖT';
          break;
        case 33:
          text = 'STR';
          break;
        default:
          text = 'FT';
      }
    } else if (options.startTime && options.getStartTime) {
      text = svs.themes.formatTime(options.startTime);
    }

    return text;
  };

})(svs);

 })(window);